import { CSSProperties } from 'react'

export type Icons =
  | 'rechteckig'
  | '18658'
  | 'quadratisch'
  | '18667'
  | 'laeufer'
  | '19693'
  | 'rund'
  | '18661'
  | 'oval'
  | '18673'
  | 'sonderform'
  | '37515'
  | 'wuerfel'
  | '38255'

export type Props = {
  name: Icons
  className?: string
  viewBox?: string
  setWidth?: number
  setHeight?: number
  style?: CSSProperties
}

export const FormIcon = ({
  name,
  className = '',
  viewBox,
  setWidth,
  setHeight = setWidth,
  style,
}: Props) => {
  const selectIcon = () => {
    switch (name) {
      case 'quadratisch':
      case '18667':
        return {
          height: 26,
          width: 26,
          icon: (
            <>
              <rect x="0.5" width="26" height="26" fill="#E5AA70" />
            </>
          ),
        }
      case 'laeufer':
      case '19693':
        return {
          height: 26,
          width: 8,
          icon: (
            <>
              <rect width="8" height="26" fill="#E5AA70" />
            </>
          ),
        }
      case 'oval':
      case '18673':
        return {
          height: 24,
          width: 34,
          icon: (
            <>
              <ellipse cx="17" cy="12" rx="17" ry="12" fill="#E5AA70" />
            </>
          ),
        }
      case 'rund':
      case '18661':
        return {
          height: 26,
          width: 26,
          icon: (
            <>
              <rect x="0.5" width="26" height="26" rx="13" fill="#E5AA70" />
            </>
          ),
        }
      case 'sonderform':
      case '37515':
        return {
          height: 26,
          width: 22,
          icon: (
            <>
              <g clipPath="url(#clip0_640_26653)">
                <path
                  d="M27.6491 0.763815C27.6238 0.760335 27.598 0.757434 27.5727 0.753954C25.1385 0.45349 22.7267 1.2789 20.3317 1.59096C16.2422 2.12403 12.1898 1.32008 8.11658 1.74003C4.29316 2.13505 1.18199 4.09735 0.570197 8.26441C-0.00960386 12.2134 3.12682 16.1757 5.83611 18.5974C8.53249 21.0075 11.8631 22.9228 15.2342 24.1078C18.1988 25.1502 21.6962 25.8659 24.7355 24.736C26.5114 24.0759 27.6474 22.9332 28.381 21.1496C29.1028 19.3944 29.4603 17.4361 30.5587 15.8665C31.8592 14.008 33.6721 12.3485 34.2772 10.0678C35.457 5.61881 31.7655 1.30616 27.6491 0.763815Z"
                  fill="#E5AA70"
                />
              </g>
              <defs>
                <clipPath id="clip0_640_26653">
                  <rect
                    width="34"
                    height="24.6207"
                    fill="white"
                    transform="translate(0.5 0.689697)"
                  />
                </clipPath>
              </defs>
            </>
          ),
        }
      case 'rechteckig':
      case '18658':
        return {
          height: 28,
          width: 16,
          icon: (
            <>
              <rect width="16" height="28" fill="#E5AA70" />
            </>
          ),
        }
      default:
        return { icon: null, width: 24, height: 24 }
    }
  }

  const { icon, width, height } = selectIcon()

  return (
    <svg
      className={className}
      viewBox={viewBox ? viewBox : `0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      width={setWidth || width}
      height={setHeight || height}
      style={{ color: 'inherit', ...style }}
    >
      {icon}
    </svg>
  )
}
